import React from 'react';

import * as S from './styles';
import { DateText, DocumentLabel, DocumentNumber } from '../../components';

export const Payer = ({ dataBilling }) => {
  return (
    <S.Section>
      <S.PayerContainer>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
          <div>
            <S.Text>Data de Vencimento</S.Text>
            <S.SimpleText>
              <DateText date={dataBilling.invoiceDueDate} />
            </S.SimpleText>
          </div>
          <div>
            <S.Text>Cliente</S.Text>
            <S.SimpleText>{dataBilling?.payerName}</S.SimpleText>
          </div>
          <div>
            <S.Text>
              <DocumentLabel number={dataBilling.payerDocumentNumber} />
            </S.Text>
            <S.SimpleText>
              <DocumentNumber number={dataBilling.payerDocumentNumber} />
            </S.SimpleText>
          </div>
          <div>
            <S.Text>Endereço</S.Text>
            <S.SimpleText>{dataBilling?.payerAddress}</S.SimpleText>
          </div>
        </div>
      </S.PayerContainer>
    </S.Section>
  );
};
